import { render, staticRenderFns } from "./DocumentosSolicitados.vue?vue&type=template&id=56477240&scoped=true"
import script from "./DocumentosSolicitados.vue?vue&type=script&lang=js"
export * from "./DocumentosSolicitados.vue?vue&type=script&lang=js"
import style0 from "./DocumentosSolicitados.vue?vue&type=style&index=0&id=56477240&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56477240",
  null
  
)

export default component.exports